import { useEffect, useRef, useState } from "react";

import styled from "styled-components/macro";

import ManagePaymentMethodsScreen from "Payments/PaymentPage/ManagePaymentMethodsScreen";
import ModifyOrCancelScreen from "Payments/PaymentPage/ModifyOrCancelScreen";
import PaymentFormScreen from "Payments/PaymentPage/PaymentFormScreen";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import SuccessScreen from "Payments/PaymentPage/SuccessScreen";
import { mockData } from "Payments/PaymentPage/mockData";
import classNames from "classnames";
import { motion } from "framer-motion";

import {
  SharedResizingChild,
  SharedResizingContainer,
} from "UI/SharedResizingArea2";

import { paymentScreens } from "./paymentScreens";
import { useSetCurrentPaymentScreen } from "./useSetCurrentPaymentScreen";

export default function PaymentScreenRouter() {
  const { state } = usePaymentPage();
  const [triggerSetFormStage, setTriggerSetFormStage] = useState(null);
  useSetCurrentPaymentScreen();

  const currentScreen = mockData.forceScreen || state.currentScreen;

  if (!currentScreen) return null;

  return (
    <SharedResizingContainer>
      <SharedResizingChild
        resizeKey="modifyOrCancel"
        show={currentScreen === paymentScreens.modifyOrCancel}
        side="left"
      >
        <ModifyOrCancelScreen
          showing={currentScreen === paymentScreens.modifyOrCancel}
        />
      </SharedResizingChild>

      <SharedResizingChild
        resizeKey="paymentForm"
        side={
          currentScreen === paymentScreens.modifyOrCancel ? "right" : "left"
        }
        show={currentScreen === paymentScreens.paymentForm}
      >
        <PaymentFormScreen
          showing={currentScreen === paymentScreens.paymentForm}
          triggerSetFormStage={triggerSetFormStage}
          resetTrigger={() => setTriggerSetFormStage(null)}
        />
      </SharedResizingChild>
      <SharedResizingChild
        resizeKey="managePaymentMethods"
        side="right"
        show={currentScreen === paymentScreens.managePaymentMethods}
      >
        <ManagePaymentMethodsScreen
          showing={currentScreen === paymentScreens.managePaymentMethods}
          setFormStage={setTriggerSetFormStage}
        />
      </SharedResizingChild>
      <SharedResizingChild
        resizeKey="success"
        side="right"
        show={currentScreen === paymentScreens.success}
      >
        <SuccessScreen showing={currentScreen === paymentScreens.success} />
      </SharedResizingChild>
    </SharedResizingContainer>
  );
}
